import { z } from 'zod';

const campaignListSchema = z.object({
  campaignId: z.number(),
  campaignName: z.string(),
  reportType: z.enum(['custom', 'weekly', 'partner']),
  reportId: z.number(),
  reportDate: z.string(),
  advertiserName: z.string(),
  advertiserId: z.number(),
  advertiserTeamName: z.string(),
  advertiserTeamId: z.number(),
  campaignStartDate: z.string(),
  campaignEndDate: z.string(),
  impressions: z.number(),
  visitLift: z.number().nullable(),
  salesLift: z.number().nullable(),
  lciVersion: z.number(),
  approvalStatus: z.enum(['approved', 'approved_visit_metrics', 'pending']),
  partnerSlug: z.string().nullable(),
  latestReportIdWithSales: z.number().nullable(),
  campaignType: z.enum(['visitation', 'cpg', 'rsl']),
});

export const campaignListsResponse = z.object({
  data: z.object({
    campaignLists: z.array(campaignListSchema),
    total: z.number(),
  }),
});

const trendSchema = z.object({
  reportDate: z.string(),
  trendValue: z.number().nullable(),
});

export const trendsResponse = z.object({
  data: z.record(
    z.string(),
    z.object({
      visit: z.array(trendSchema),
      sales: z.array(trendSchema),
    })
  ),
});

export type TrendsResponse = z.infer<typeof trendsResponse>;

export type CampaignListsResponse = z.infer<typeof campaignListsResponse>;

export type CampaignListEntry =
  CampaignListsResponse['data']['campaignLists'][number];
export type CampaignListAttribute = keyof CampaignListEntry;
